import React from 'react';
import PropTypes from 'prop-types';
import { menuConfig } from './MenuConfig';

const Sidebar = ({
  user, collapsed, setCollapsed, setActivePage,
}) => {
  const role = user?.role || 'receptionist';
  const menuItems = menuConfig[role];

  // handlers for hover expand/collapse
  const handleMouseEnter = () => {
    if (collapsed) setCollapsed(false);
  };

  const handleMouseLeave = () => {
    if (!collapsed) setCollapsed(true);
  };

  return (
    <div
      className={`sidebar ${collapsed ? 'collapsed' : ''} shadow-md`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul className="menu p-4 space-y-4">
        <p className="text-gray-600 uppercase text-xs tracking-wider font-bold">
          {collapsed ? 'Menu' : 'Main Menu'}
        </p>

        {menuItems.map(({ key, label, icon }) => (
          <button
            key={key}
            type="button"
            className="sidebar-item flex items-center gap-2 cursor-pointer"
            onClick={() => setActivePage(key)}
          >
            <div className="icon-wrapper flex items-center justify-center">
              {icon}
            </div>
            {!collapsed && <span className="sidebar-label">{label}</span>}
          </button>
        ))}
      </ul>
    </div>
  );
};

Sidebar.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
  }).isRequired,
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  setActivePage: PropTypes.func.isRequired,
};

export default Sidebar;
